import $ from 'jquery';
import { generateIconElement, ICON } from "../../Icons/Icons";
import { FEATURE_NAMES } from "../../MVC/rolesHelper";
import AlertNotification from "../Notifications/AlertNotification";

/**
 * UserPasswordChangeModal - A component for handling password change
 */
class AuthRequiredModal {
  /**
   * Get the modal template
   * @returns {string} HTML template
   */
  modalTemplate() {
    return `
<div class="confirm-modal confirm-modal--light-theme middle space-select-modal">
  <div class="confirm-dialog">
    ${generateIconElement(ICON.CLOSE, { classes: 'confirm-close' }).prop('outerHTML')}
    
    <div class="space-select-modal__title" data-lang="space-select-auth-required">
      ${$trans('space-select-auth-required')}
    </div>
    
    <div class="confirm-footer my-5">
      <button id="space-select-login" class="buttn primary" data-lang="login-text">
        ${$trans('login-text')}
      </button>
      
      <button id="space-select-signup" class="buttn primary" data-lang="register-text">
        ${$trans('register-text')}
      </button>
    </div>
    
    <div class="space-select-modal__differences-question" data-lang="space-select-differences-question">
      ${$trans('space-select-differences-question')}
    <div
  </div>
</div>
    `;
  }

  ///constructor
  constructor({ model }) {
    this.model = model;

    this.render();
    this.addEventListeners();
  }

  render() {
    this.$modal = $(this.modalTemplate());
    $('body').append(this.$modal);
  }

  addEventListeners() {
    this.$loginButton = this.$modal.find('#space-select-login');
    this.$signupButton = this.$modal.find('#space-select-signup');

    this.$modal.find('.confirm-close').on('click', () => {
      this.hide();
    });

    this.$loginButton.on('click', () => {
      this.hide()
      openLoginModal();
    });

    this.$signupButton.on('click', () => {
      this.hide()
      openRegisterModal();
    });
  }

  show() {
    this.$modal.addClass('visible').show();
  }

  hide() {
    this.$modal.removeClass('visible').hide();
  }
}

export default AuthRequiredModal;
